import * as React from "react";

import "./textarea.scss";

const sizeClasses = {
  small: "textarea-small",
  large: "textarea-large",
};

const Textarea = (props) => {
  const {
    label,
    id,
    value,
    onChange,
    size,
    leftIcon,
    rightIcon,
    onClickLeftIcon,
    onClickRightIcon,
    onFocus,
    onBlur,
    required,
    hasError,
    errorMessage,
    children,
    ...rest
  } = props;

  const [textValue, setTextValue] = React.useState(value || "");

  const [isHovered, setIsHovered] = React.useState(false);
  const [isFocused, setIsFocused] = React.useState(false);

  React.useEffect(() => {
    setTextValue(value || "");
  }, [value]);

  const onFocusTextarea = (e) => {
    setIsFocused(true);
    onFocus?.(e);
  };

  const onBlurTextarea = (e) => {
    setIsFocused(false);
    onBlur?.(e);
  };

  const onMouseEnterGroup = () => {
    setIsHovered(true);
  };

  const onMouseLeaveGroup = () => {
    setIsHovered(false);
  };
  const onChangeValue = (e) => {
    setTextValue(e.target.value);
    onChange?.(e);
  };

  const textareaId = id || `textarea-${Math.floor(Math.random() * 1000)}`;

  return (
    <div className={`box-textarea ${sizeClasses[size] || ""}`}>
      {label && (
        <label htmlFor={textareaId}>
          {label}
          {required && <span className="text-danger"> *</span>}
        </label>
      )}
      <div
        className={`group-textarea ${hasError ? "error-field" : ""}`}
        onMouseEnter={onMouseEnterGroup}
        onMouseLeave={onMouseLeaveGroup}
      >
        {leftIcon && (
          <label
            htmlFor={textareaId}
            className={`icon icon-left ${
              onClickLeftIcon ? "cursor-pointer" : ""
            }`}
            onClick={onClickLeftIcon}
          >
            {leftIcon}
          </label>
        )}
        <textarea
          id={textareaId}
          onChange={onChangeValue}
          value={textValue}
          onFocus={onFocusTextarea}
          onBlur={onBlurTextarea}
          required={required}
          {...rest}
        >
          {children}
        </textarea>
        {rightIcon && (
          <label
            htmlFor={textareaId}
            className={`icon icon-right ${
              onClickRightIcon ? "cursor-pointer" : ""
            }`}
            onClick={onClickRightIcon}
          >
            {typeof rightIcon === "function"
              ? rightIcon({ isHovered, isFocused })
              : rightIcon}
          </label>
        )}
      </div>
      {hasError && errorMessage && (
        <div className="text-danger">{errorMessage}</div>
      )}
    </div>
  );
};

export default Textarea;
